import React, { useState } from 'react';
import { db } from '../../firebase/config';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { useAuth } from '../../contexts/AuthContext';
import { useToast } from '../../contexts/ToastContext';

const AddYearModal = ({ isOpen, onClose }) => {
    const { currentUser, userData, isAdmin } = useAuth();
    const { showToast } = useToast();
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        yearName: '',
        startDate: '',
        endDate: '',
        theme: '',
        description: ''
    });

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.id]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!isAdmin) {
            showToast('Admin privileges required', 'error');
            return;
        }

        setLoading(true);

        try {
            await addDoc(collection(db, 'ministryYears'), {
                yearName: formData.yearName,
                startDate: new Date(formData.startDate),
                endDate: new Date(formData.endDate),
                theme: formData.theme,
                description: formData.description,
                createdAt: serverTimestamp(),
                createdBy: currentUser.uid,
                createdByName: userData?.firstName + ' ' + userData?.lastName,
                active: true
            });

            showToast('Ministry year added successfully!', 'success');
            onClose();
            setFormData({
                yearName: '',
                startDate: '',
                endDate: '',
                theme: '',
                description: ''
            });
        } catch (error) {
            console.error('Error adding ministry year:', error);
            showToast('Error adding ministry year', 'error');
        } finally {
            setLoading(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={e => e.stopPropagation()}>
                <div className="modal-header">
                    <h3 className="modal-title">
                        <i className="fas fa-calendar-plus"></i> Add New Ministry Year
                    </h3>
                    <button className="close-modal" onClick={onClose}>&times;</button>
                </div>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label htmlFor="yearName">Year Name *</label>
                        <input
                            type="text"
                            id="yearName"
                            className="form-control"
                            placeholder="e.g., 2024-2025 Ministry Year"
                            value={formData.yearName}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="startDate">Start Date *</label>
                        <input
                            type="date"
                            id="startDate"
                            className="form-control"
                            value={formData.startDate}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="endDate">End Date *</label>
                        <input
                            type="date"
                            id="endDate"
                            className="form-control"
                            value={formData.endDate}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="theme">Ministry Theme</label>
                        <input
                            type="text"
                            id="theme"
                            className="form-control"
                            placeholder="e.g., Growing in Grace"
                            value={formData.theme}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="description">Description</label>
                        <textarea
                            id="description"
                            className="form-control"
                            rows="3"
                            placeholder="Brief description of the ministry year goals"
                            value={formData.description}
                            onChange={handleChange}
                        ></textarea>
                    </div>
                    <button 
                        type="submit" 
                        className="btn btn-admin" 
                        style={{ width: '100%' }}
                        disabled={loading}
                    >
                        {loading ? (
                            <>
                                <i className="fas fa-spinner fa-spin"></i> Creating...
                            </>
                        ) : (
                            <>
                                <i className="fas fa-save"></i> Create Ministry Year
                            </>
                        )}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default AddYearModal;
